import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import ru from 'vuetify/src/locale/ru'

Vue.use(Vuetify);
const preset = {
    breakpoint: {
        thresholds: {
            xs: 550,
            sm: 680,
            md: 750,
            lg: 830,
        }, // отмечается верхняя граница
        scrollBarWidth: 0,
    },
    icons: {
        iconfont: 'mdi',
        values: {
            checkboxOff: 'mdi-checkbox-blank-outline',
            unfold: 'mdi-chevron-down',
            expand: 'mdi-chevron-down',
            dropdown: 'mdi-chevron-down',
            delete: 'mdi-close'
        }
    },
    lang: {
        locales: { ru },
        current: 'ru'
    }
}
const vuetifyInst = new Vuetify(preset);
export default vuetifyInst;